module.exports = require("./twq.d.ts");